import React from 'react';

const ComeHomeToNaturalGas = () => {
    return (
        <div className="panel panel-default infobox">
            <div className="panel-body">
                <h4 className="text-primary">Come home to natural gas</h4>
                <p>Be inspired by the many ways you can use natural gas in your home – both indoors and outdoors.</p>
                <i className="fa fa-angle-right icon-widget-gas" />
                <a href="http://www.fortisbc.com/NaturalGas/Homes/AppliancesHeatingSystems/Pages/default.aspx"
                     className="link-widget box-link"  target="_blank"> Go to appliances and heating system</a>

            </div>
        </div>
    );
};

export default ComeHomeToNaturalGas;

